module.exports = __webpack_public_path__ + "img/cooperation19.ea223eac.png";